var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHoldall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.134 4l5.812.001c.885 0 1.608.883 1.608 1.982v2.544c0 .08 0 .188-.027.268h.723v15.428H8.858V8.82h.696c-.027-.107-.027-.188-.027-.295V5.982C9.527 4.884 10.25 4 11.134 4zM7.518 8.795v15.402H6.313V8.795h1.205zM5 8.795v15.402H3.205A1.2 1.2 0 012 22.99v-12.99a1.2 1.2 0 011.205-1.206H5zm19.767 0c.67 0 1.206.536 1.233 1.206v12.99a1.2 1.2 0 01-1.205 1.206h-1.688V8.795zm-2.972 0v15.402H20.59V8.795h1.205zm-4.849-3.188h-5.813c-.161 0-.295.161-.295.349V8.5c0 .134.053.242.134.295h1.42c-.08.161-.107.349-.107.536v.91c0 .75.616 1.367 1.367 1.367h.91c.75 0 1.366-.617 1.366-1.367v-.91c0-.187-.026-.375-.106-.536h1.286a.384.384 0 00.133-.295V5.956c0-.188-.134-.349-.295-.349zM14.75 9.036c.107 0 .187.08.187.187v.147c.002.3.007.962.028 1.086.027.16-.08.267-.241.267h-1.259c-.106 0-.187-.106-.188-.214V9.223c0-.107.08-.187.187-.187z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgHoldall;